import { i } from "./main19.js";
import { _ as o } from "./main20.js";
import { _ as s } from "./main21.js";
import { t as a } from "./main22.js";
var m = i, n = o, _ = s, f = a;
function p(r, t) {
  return m(r) ? r : n(r, t) ? [r] : _(f(r));
}
var c = p;
export {
  c as _
};
